import ListProcesses from "@/views/packing_house/process/exec_steps/ListProcesses.vue";
import ShowProcess from "@/views/packing_house/process/exec_steps/ShowProcess.vue";
import ShowStep from "@/views/packing_house/process/exec_steps/ShowStep.vue";
import NewExecStep from "@/views/packing_house/process/exec_steps/NewExecStep.vue";
import ShowExecStep from "@/views/packing_house/process/exec_steps/ShowExecStep.vue";
import EditExecStep from "@/views/packing_house/process/exec_steps/EditExecStep.vue";
import NewExecAttr from "@/views/packing_house/process/exec_steps/NewExecAttr.vue";

import { routerUtilities } from "@/components/views/mixins/module_routes.js";
const [META, routeName] = routerUtilities({
  entity: "ph",
  role: "process",
  permission: "exec_steps",
});

export default [
  {
    path: "/ph/:packing_house_id/process/exec_steps",
    name: routeName(""),
    props: true,
    redirect: { name: routeName("list_processes") },
  },
  {
    path: "/ph/:packing_house_id/process/exec_steps/list_processes",
    name: routeName("list_processes"),
    component: ListProcesses,
    props: true,
    meta: META,
  },
  {
    path: "/ph/:packing_house_id/process/exec_steps/show_process/:packing_house_process_id",
    name: routeName("show_process"),
    component: ShowProcess,
    props: true,
    meta: META,
  },
  {
    path: "/ph/:packing_house_id/process/exec_steps/:packing_house_process_id/show_step/:process_line_step_id",
    name: routeName("show_step"),
    component: ShowStep,
    props: true,
    meta: META,
  },
  {
    path: "/ph/:packing_house_id/process/exec_step/:packing_house_process_id/new_exec_step/:process_line_step_id",
    name: routeName("new_exec_step"),
    component: NewExecStep,
    props: true,
    meta: META,
  },
  {
    path: "/ph/:packing_house_id/process/exec_step/:packing_house_process_id/show_exec_step/:process_line_step_id/:id",
    name: routeName("show_exec_step"),
    component: ShowExecStep,
    props: true,
    meta: META,
  },
  {
    path: "/ph/:packing_house_id/process/exec_step/:packing_house_process_id/edit_exec_step/:process_line_step_id/:id",
    name: routeName("edit_exec_step"),
    component: EditExecStep,
    props: true,
    meta: META,
  },
  {
    path: "/ph/:packing_house_id/process/exec_step/:packing_house_process_id/new_exec_attr/:process_line_step_id/:id",
    name: routeName("new_exec_attr"),
    component: NewExecAttr,
    props: true,
    meta: META,
  }
];
